"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var messages = (0, _reactIntl.defineMessages)({
  northEast: {
    "id": "PolarChart.quadrantLabel.northEast",
    "defaultMessage": "Purpose"
  },
  southEast: {
    "id": "PolarChart.quadrantLabel.southEast",
    "defaultMessage": "Result"
  },
  southWest: {
    "id": "PolarChart.quadrantLabel.southWest",
    "defaultMessage": "Process"
  },
  northWest: {
    "id": "PolarChart.quadrantLabel.northWest",
    "defaultMessage": "Experience"
  }
});

var QuadrantLabels = function QuadrantLabels(_ref) {
  var theme = _ref.theme,
      bounds = _ref.bounds,
      show = _ref.show,
      hidden = _ref.hidden,
      intl = _ref.intl;
  if (hidden) return null;
  var north = show.north,
      east = show.east,
      south = show.south,
      west = show.west;
  var padding = 20;
  var font = {
    fontFamily: theme.font2,
    fontSize: 18,
    fontWeight: '300'
  };
  var bgStroke = {
    strokeWidth: '10px',
    // This allows the text to be read clearly over darker/hatched background
    stroke: theme.tertiary
  };
  var texts = [];

  if (north && east) {
    var position = {
      x: bounds.x.max - padding,
      y: bounds.y.min + padding,
      textAnchor: 'end',
      alignmentBaseline: 'hanging'
    };
    var content = intl.formatMessage(messages.northEast);
    texts.push( /*#__PURE__*/_react.default.createElement("text", _extends({}, bgStroke, font, position), content));
    texts.push( /*#__PURE__*/_react.default.createElement("text", _extends({}, font, position), content));
  }

  if (south && east) {
    var _position = {
      x: bounds.x.max - padding,
      y: bounds.y.max - padding,
      textAnchor: 'end',
      alignmentBaseline: 'baseline'
    };

    var _content = intl.formatMessage(messages.southEast);

    texts.push( /*#__PURE__*/_react.default.createElement("text", _extends({}, bgStroke, font, _position), _content));
    texts.push( /*#__PURE__*/_react.default.createElement("text", _extends({}, font, _position), _content));
  }

  if (south && west) {
    var _position2 = {
      x: bounds.x.min + padding,
      y: bounds.y.max - padding,
      textAnchor: 'start',
      alignmentBaseline: 'baseline'
    };

    var _content2 = intl.formatMessage(messages.southWest);

    texts.push( /*#__PURE__*/_react.default.createElement("text", _extends({}, bgStroke, font, _position2), _content2));
    texts.push( /*#__PURE__*/_react.default.createElement("text", _extends({}, font, _position2), _content2));
  }

  if (north && west) {
    var _position3 = {
      x: bounds.x.min + padding,
      y: bounds.y.min + padding,
      textAnchor: 'start',
      alignmentBaseline: 'hanging'
    };

    var _content3 = intl.formatMessage(messages.northWest);

    texts.push( /*#__PURE__*/_react.default.createElement("text", _extends({}, bgStroke, font, _position3), _content3));
    texts.push( /*#__PURE__*/_react.default.createElement("text", _extends({}, font, _position3), _content3));
  }

  return /*#__PURE__*/_react.default.createElement("g", null, texts);
};

QuadrantLabels.propTypes = {
  bounds: _propTypes.default.shape({
    x: _propTypes.default.shape({
      min: _propTypes.default.number.isRequired,
      max: _propTypes.default.number.isRequired
    }),
    y: _propTypes.default.shape({
      min: _propTypes.default.number.isRequired,
      max: _propTypes.default.number.isRequired
    })
  }).isRequired,
  show: _propTypes.default.shape({
    north: _propTypes.default.bool,
    east: _propTypes.default.bool,
    south: _propTypes.default.bool,
    west: _propTypes.default.bool
  }),
  hidden: _propTypes.default.bool
};
QuadrantLabels.defaultProps = {
  show: {
    north: true,
    east: true,
    south: true,
    west: true
  },
  hidden: false
};

var _default = (0, _reactIntl.injectIntl)((0, _styledComponents.withTheme)(QuadrantLabels));

exports.default = _default;
//# sourceMappingURL=QuadrantLabels.js.map